import { render, staticRenderFns } from "./LcNumPadding.vue?vue&type=template&id=10bd0546&scoped=true"
import script from "./LcNumPadding.vue?vue&type=script&lang=js"
export * from "./LcNumPadding.vue?vue&type=script&lang=js"
import style0 from "./LcNumPadding.vue?vue&type=style&index=0&id=10bd0546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd0546",
  null
  
)

export default component.exports